import React from 'react'
import AgeRangeSlider from '../main/ui/slider/AgeRangeSlider'

const LiveAgeRangeSlider = props => {
  const max = props.value?.max || props.maxValue
  const min = props.value?.min || props.minValue

  const [value, setValue] = React.useState({ min, max })

  const maxInputFormElement = document.getElementById(props.maxInputId)
  const minInputFormElement = document.getElementById(props.minInputId)

  const handleChange = updatedValues => {
    const { max: updatedMax, min: updatedMin } = updatedValues

    if (maxInputFormElement) {
      maxInputFormElement.value = updatedMax || props.maxValue
      maxInputFormElement.dispatchEvent(new Event('input', { bubbles: true }))
    }

    if (minInputFormElement) {
      minInputFormElement.value = updatedMin || props.minValue
      minInputFormElement.dispatchEvent(new Event('input', { bubbles: true }))
    }

    setValue(updatedValues)
  }

  return <AgeRangeSlider {...props} value={value} onChange={handleChange} />
}

export default LiveAgeRangeSlider
